import * as globals from './browser.js';
window['gauntface'] = window['gauntface'] || {};
Object.assign(window['gauntface'], globals);